// components/SudokuVideo.tsx
import React from 'react';
import '../../../../../../Assets/styles/LandingStyles/LandingComponentsStyles/BeginnersGuideStyles/SudokuBasicsStyles/SudokuVideo.css';

const SudokuVideo = () => (
    <div className="tutorial-step-container">
        <div className="video-placeholder">
            <iframe
                src="https://www.youtube.com/embed/AkuSKGK0RJ0?si=mpSvJ54ISrf71BFI"
                title="Sudoku Tutorial Video"
                allowFullScreen
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope;"
                className="video-iframe fullscreen-video"
            />

        </div>
    </div>
);

export default SudokuVideo;